import { WeatherLoader } from '@fe/weather';
import { updateWeatherProducts } from '../slices/weather-slice';
import { startAppListening } from './listener-middleware';

export function startWeatherRecordingListener() {
    startAppListening({
        actionCreator: updateWeatherProducts,
        effect: async (action, api) => {
            // We only record live weather
            const state = api.getState();
            if (action.payload.type !== 'live' || !state.global.recording.active) {
                return;
            }

            // Get the products that we should record
            const updatedAndRecorded = action.payload.products.filter((p) => state.settings.alwaysLoadWeather.some((x) => p.id === x.id));
            if (updatedAndRecorded.length === 0) {
                return;
            }

            await WeatherLoader.record(
                updatedAndRecorded.map((prod) => ({
                    frame: 'latest', // Record only the latest frame since this is an update
                    product: prod
                }))
            );
        }
    });
}
